export default [
	{
		modulo: 2,
		privilegio: 2,
		routerName: 'ordem',
		routerPath: '/ordem-missao',
		componentName: 'OrdemMissao',
		componentPath: 'modules/layout/ordem-missao/mg-siga/main',
		clientsComponentPath: [
			// id do ibama
			{
				clientId: [5],
				componentPath: 'modules/layout/ordem-missao/ibama/main'
			},
			// ID DA AEROTERRA
			{
				clientId: [13, 21],
				componentPath: 'modules/layout/ordem-missao/aero-terra/main'
			},
			// id pm-es
			{
				clientId: [18],
				componentPath: 'modules/layout/ordem-missao/pm-es/main'
			},
			// id do gta-sergipe
			{
				clientId: [24],
				componentPath: 'modules/layout/ordem-missao/sergipe/main'
			},
			// id do maranhao
			{
				clientId: [10],
				componentPath: 'modules/layout/ordem-missao/maranhao/main'
			},
			// id casa militar bahia
			{
				clientId: [8],
				componentPath: 'modules/layout/ordem-missao/cm-bahia/main'
			},
			// id da henrimar
			{
				clientId: [12],
				componentPath: 'modules/layout/ordem-missao/henrimar/main'
			},
			{
				clientId: [25, 37],
				componentPath: 'modules/layout/ordem-missao/vale/main'
			}
		]
	},
	{
		modulo: 2,
		privilegio: 353,
		routerName: 'tabela-de-voos',
		routerPath: '/tabela-de-voos',
		componentName: 'TabelaDeVoos',
		componentPath: 'modules/layout/tabela-de-voos/main'
	}
]
